import script from "./Signcopy.vue?vue&type=script&lang=ts&setup=true"
export * from "./Signcopy.vue?vue&type=script&lang=ts&setup=true"

import "./Signcopy.vue?vue&type=style&index=0&id=6603f038&scoped=true&lang=less"

import exportComponent from "D:\\Code\\BranchManageSystem\\UI\\risfond-branchmanagementsystem\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6603f038"]])

export default __exports__